import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboard'
import { useGetemployeeTrainings } from '../../redux/employee/hook/training'
import {
  PAGINATION_DEFAULT,
  queryStatusConfig,
  trainingStatusConfig,
} from '../../utils/constants'
import DataTable from '../../components/datatable'
import QueryModal from '../../components/modal/hr-section/employee-query/query-modal'
import { useGetQueries } from '../../redux/human-resources/hook/queries'

const QueryPage = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    satusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })
  const { data: queries } = useGetQueries(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const [showEmployeeQuery, setShowEmployeeQuery] = useState(false)
  const [queryData, setQueryData] = useState(null)

  const tableConfig = {
    headers: ['Date Added', 'Employee Name', 'Subject', 'Status'],
    keys: ['date_created', 'employeeName', 'subject', 'status'],
    mobileHeader: {
      left: {
        title: 'Date Added',
        key: 'date_created',
      },
      right: {
        title: 'Employee Name',
        key: 'employeeName',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Reply query',
      color: 'green',
      action: (id) => {
        let index = queries.data.findIndex((item) => item.id === id)
        setQueryData(queries.data[index])
        setShowEmployeeQuery(true)
      },
    },
  ]

  return (
    <DashboardLayout title='Employee Queries'>
      <div className='flex flex-col bg-white shadow-md rounded'>
        {showEmployeeQuery ? (
          <QueryModal
            isOpen={showEmployeeQuery}
            query={queryData}
            closeModal={() => setShowEmployeeQuery(false)}
          />
        ) : null}
        <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
          <div className='p3-bold header-4'>Query</div>
        </div>
        <hr className='divider mt-2 mb-2' />
        <DataTable
          data={queries}
          tableConfig={tableConfig}
          actionConfig={actionConfig}
          statusConfig={queryStatusConfig}
          updatePagination={(data) => setPagination(data)}
          computedActions={true}
          searchData={true}
        />
      </div>
    </DashboardLayout>
  )
}

export default QueryPage
